<template>
  <ion-card color="light" class="border-default no-shadow spacing-xs filter-card mt-zero bg-white ion-no-margin">
    <ion-row>
      <ion-col size="12">
        <h4 class="h4 text-weight-bold text-align-left text-color-placeholder">{{ t('profile.contactData') }}</h4>
        <p class="padding mt-8 text-weight-bold text-color-placeholder">{{ t('profile.labels.phoneNumber') }}</p>
        <ion-label class="text-color-placeholder text-weight-bold">
          +{{ user?.prefixPhone }} {{ user?.phoneNumber }}
        </ion-label>
      </ion-col>
    </ion-row>
  </ion-card>
</template>
<script setup lang="ts">
  import { IonCard, IonCol, IonRow, IonLabel } from '@ionic/vue';
  import { useI18n } from 'vue-i18n';
  import { useAuth } from '@/composables/useAuth';
  const { user } = useAuth();
  const { t } = useI18n();
</script>
<style scoped lang="scss">
  ion-button {
    height: 35px;
  }
</style>
